<template>
    <div>
        <section>
            <div class="inner row5">
                <div class="title">
                    <h1>공지사항 관리</h1>
                </div>
                <section>
                    <div class="row4">
                        <div class="topContent flex">
                            <div class="left flex">
                                <p>총 <span>{{ totalNo }}</span>건</p>
                                <p>현재 페이지 {{ nowPage }} / {{ totalPage }}</p>
                            </div>
                            <div>
                                <input type="text" class="searchInput" />
                                <input type="button" value="검 색" class="searchBtn searchBtnCmmn" />
                                <input type="button" value="검색초기화" class="searchResetBtn searchBtnCmmn" />
                                <div class="btnBox blankLeft inlineB">
                                    <button class="greenBtn smBtn" @click="writeBtn()">등록</button>
                                    <button class="orangeBtn smBtn">삭제</button>
                                </div>
                            </div>
                        </div>
                        <div class="tableContainer">
                            <div class="sampleTemplate">
                                <b-table
                                id="table"
                                :fields="fields"
                                :items="items"
                                :per-page="perPage"
                                :current-page="currentPage"
                                @row-clicked="onRowClicked"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                hover
                                >
                                    <template #cell(STATUS)="data">
                                        <span v-html="data.value"></span>
                                    </template>
                                </b-table>
                                <b-pagination
                                v-model="currentPage"
                                :total-rows="totalCnt"
                                :per-page="perPage"
                                aria-controls="table">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </div>   
</template>

<script>

export default {
    name: 'Home',
    data() {
        return {
            totalNo: 1,
            nowPage: 1,
            totalPage: 2,
            perPage: 4,
            currentPage: 1,
            totalCnt: 0,
            // sample items
            items: [
                {
                    ID: '1',
                    STATUS: '<span class="notSubmit">미제출</span>',
                    SURVEYTITLE: '공지사항 입니다.공지사항 입니다.',
                    SURVEYDESCRIPT: '2021.06.04',
                    Count: '5',
                    REGDATE: '2021.06.23',
                    OUTDATE: '2021.06.24',
                    isActive: true
                },
                {
                    ID: '1',
                    STATUS: '미제출',
                    SURVEYTITLE: '공지사항 입니다.공지사항 입니다.',
                    SURVEYDESCRIPT: '2021.06.04',
                    Count: '5',
                    REGDATE: '2021.06.23',
                    OUTDATE: '2021.06.24',
                }
            ],
            //sortBy: 최초 보이는 화면의 sort 기준, sortDesc 순서
            sortBy: 'ID',
            sortDesc: false,
            fields: [
                {
                    key: 'ID',
                    label: 'No',
                    sortable: false,
                    sortDirection: 'desc',
                    class: 'text-center'
                },
                {
                    key: 'STATUS',
                    label: '상태',
                    sortable: false,
                    isActive: true,
                    class: 'statusOn text-center',
                },
                {
                    key: 'SURVEYTITLE',
                    label: '설문 제목',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: 'SURVEYDESCRIPT',
                    label: '설문지 설명',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: 'Count',
                    label: '조회수',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: 'REGDATE',
                    label: '등록일',
                    sortable: false,
                    class: 'text-center'
                },
                {
                    key: 'OUTDATE',
                    label: '제출일',
                    sortable: false,
                    class: 'text-center'
                }
            ]
        }
    },
    methods:{
        goback(){
            this.$router.go(-1) 
        },
        writeBtn() {
            this.$router.push('/admin/noticeManagementWrite');
        },
        onRowClicked() {
            this.$router.push('/admin/noticeManagementDetail');
        }
    }
}
</script>

<style scoped lang="scss">
    .sampleTemplate ::v-deep {
        @import "~bootstrap/dist/css/bootstrap.min";
    }
</style>